<template>
  <div class="articleoxplay">
    <el-dialog
      :visible.sync="videoplay"
      :modal-append-to-body="false"
      :before-close="colsevideo"
    >
      <div style="width: 100%;height: 100%;">
        <div class="header-wrap">
          <div class="title">
            <i class="el-icon-success"></i>
            <span>作品已生成，快去分享吧</span>
          </div>
          <div class="text-gray">作品有效期1天，分享到朋友圈集赞送会员哦</div>
        </div>
        <div class="videobox">
			<div ref="contentBox" class="contentbox">{{content}}
			<div v-if="loading" class="content loading">
				<div class="content1">
					<div class="dot"></div>
					<div class="dot"></div>
					<div class="dot"></div>
					<div class="dot"></div>
					<div class="dot"></div>
				</div>
			</div>
			</div>
        </div>

        <div class="btn-wrap">
          <div class="share-btn-wrap flex-center">
            <!-- <div class="btn-share flex-center">
              <span>扫码分享</span>
            </div> -->
            <div @click="copy($event)" style="cursor: pointer;" class="btn-down">
              <span>立即复制</span>
            </div>
			<div v-if="show_go_video" @click="goVideoUrl()" style="cursor: pointer;" class="btn-down">
			  <span>生成视频</span>
			</div>
          </div>
          <!-- <div class="tips">
            推荐使用「<a
              href="https://www.animiz.cn/videoclipmaster/?wancaiai"
              target="_blank"
              >康桥特效大师</a
            >」，一键去除视频背景
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
	fetchEventSource
} from "@microsoft/fetch-event-source";
import { Message } from 'element-ui'
import Clipboard from 'clipboard'
import {createVideo} from "@/api/article"
export default {
  data() {
    return {
	  content:'',
	  tips:'...',
      share:false,
	  aid:0,
      video_template:null,
      show_go_video:false,
	  loading:false,
      videoplay: true,
      video: {
        src: require("../../assets/20240115-141801.mp4"),
        poster: require("../../assets/history/thumb.jpg"),
      },
    };
  },
  mounted() {
	   
  },
  
 
  methods: {
    colsevideo() {
      this.$emit("colsechatbox");
    },
	rollingBottom() {
		const { width, height } = this.$refs.contentBox.getBoundingClientRect();
		this.$refs.contentBox.scrollTop = height;
	},
	save() {
		rollingBottom();
	},
	copy(event) {
		const clipboard = new Clipboard(event.target, {
	        text: () => this.content,
	    })
	    clipboard.on('success', () => {
	        clipboard.destroy()
			Message({
				message: '复制成功',
				type: 'success',
				duration: 3 * 1000
			})
	    })
	    clipboard.on('error', () => {
	        clipboard.destroy()
			Message({
				message: '复制失败',
				type: 'error',
				duration: 3 * 1000
			})
	    })
	    clipboard.onClick(event)	
	},
	goVideoUrl() {
		if(this.video_template != null) {
			// this.$router.push({ path: '/microvideo?aid=' + this.aid});
			createVideo().then(res=>{
			})
		}else {
			this.$router.push({ path: '/microvideo?aid=' + this.aid});
		}
		
	},
	startContent(chat_url, params,video_template) {
		this.video_template = video_template;
		let arr = JSON.parse(params)
		let data = {
			title : arr.template.title,
			id: arr.template.id,
			fields: arr.list
		}
		this.content = '';
		let that = this;
		let headers = {
			token:localStorage.getItem('gpt-token')
		};
		// return false;
		let eventSourcepost = fetchEventSource(chat_url, {
			method: 'POST',
			headers: headers,
			// signal: abortController,
			body: JSON.stringify(data),
			// openWhenHidden:true,
			onopen(event) {
				if (event.status != 200) {
					Message({
						message: '服务器内部错误',
						type: 'error',
						duration: 5 * 1000
					})
				} else {
					that.loading = true;
				}
			},
			onmessage(event) {
				// console.log(event)
				try {
					var content = event.data;
					if(content.indexOf('error_msg') > -1) {
						Message({
						    message: content,
						    type: 'error',
						    duration: 5 * 1000
						})
					}else {
						//console.log(content);
						//console.log(content.indexOf('lastId:') > -1);
						if(content.indexOf('lastId:') > -1) {
							that.aid = content.replace('lastId:', '').trim();
							//console.log(that.aid)
						}else {
							that.content = that.content + content;
						}
						that.rollingBottom()
					}
				} catch (error) {
					console.log(error);
					// that.ctrlAbout.abort()
				}
			},
			onerror(event) {
				// 服务异常
				console.log("onerror:", event);
				that.loading = false;
			},
			onclose(event) {
				console.log("onclose:", event);
				that.loading = false;
				if(that.video_template == null) {
					that.show_go_video = true;
				}
				that.$emit("articleGetHistory");
			}
		})
	}
	
  },
  created() {
  }
};
</script>

<style lang="less">
.articleoxplay {
  .el-dialog{
    height: 626px!important;
  }
  .header-wrap {
    text-align: center;
    padding-top: 20px;
    i {
      color: #38b865;
    }
    .title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .text-gray {
      color: #999;
      font-size: 14px;
    }
  }
  .videobox {
	width: 100%;
	height: 300px;
    overflow-y: scroll;
	overflow-x: hidden;
    border-radius: 8px;
    background-color: #f4f5f7;
    // margin: 20px 32px 0;
    box-sizing: border-box;
    video {
      width: 100%;
      display: block;
    }
	.contentbox{
		width: 100%;
		height: 100%;
		padding:20px;
		background: white;
		overflow: auto;
	}
  }

  .btn-wrap{
    padding: 32px 0 16px;
    .share-btn-wrap{
      display: flex;
      justify-content: center;
      .btn-share{
        display: inline-flex;
        width: 185px;
        height: 50px;
        font-size: 18px;
        border-radius: 8px;
        background: #f4f5f7;
        vertical-align: bottom;
        cursor: pointer;
        position: relative;
        justify-content: center;
        align-items: center;
      }
      .btn-down{
        width: 185px;
        height: 50px;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 700;
        background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
        color: #fff;
        justify-content: center;
        align-items: center;
        display: inline-flex;
        margin-left: 32px;
      }
    }
    .tips{
      margin-top: 8px;
      color: #999;
      font-size: 12px;
      text-align: center;
    }
  }
}
.loading {
		width: 140px;
		display: inline-table;
		.content1 {
			width: 140px;
			// padding: 18rpx;
			max-width: 500rpx;
			border-radius: 30rpx;
			font-size: 28rpx;

			.text {
				color: #c0c4cc;
				margin: 10rpx 0rpx 0rpx 30rpx;
			}

			.dot {
				width: 4px;
				height: 4px;
				background-color: #106eff;
				display: inline-block;
				border-radius: 4px;
				margin: 0 10px;
				animation-name: loading-beat;
				/* 动画完成一个周期所需要的时间 */
				animation-duration: 3s;
				/* 定义动画从何时开始（延迟） */
				animation-delay: 0s;
				/* 动画播放次数（无限） */
				animation-iteration-count: infinite;
			}

			.dot:nth-child(2) {
				animation-delay: .2s;
			}

			.dot:nth-child(3) {
				animation-delay: .4s;
			}

			.dot:nth-child(4) {
				animation-delay: .6s;
			}

			.dot:nth-child(5) {
				animation-delay: .8s;
			}

			// .dot:nth-child(6){
			//     animation-delay: .10s;
			// 	animation-name: loading-beat-last;
			// }

			@keyframes loading-beat {
				0% {
					transform: translateY(0) scale(1);
				}

				25% {
					transform: translateY(-8px) scale(1.5);
				}

				50%,
				75%,
				100% {
					transform: translateY(0px) scale(1);
				}
			}

			@keyframes loading-beat-last {
				0% {
					transform: translateY(0) scale(1);
				}

				25%,
				50% {
					transform: translateY(-8px) scale(1.5);
				}

				60% {
					transform: translateY(0px) scale(1);
				}
			}
		}
	}
</style>